import React, { FC, useEffect, useState } from "react";
import { VehicleType, RentalType } from "../../types";
import { useSelector } from "react-redux";
interface VehicleDetailsProps {
  totalListedVehicles: number;
  availableVehicles: number;
}

const VehicleDetails: FC = () => {
  const rentals: RentalType[] = useSelector(
    (state: any) => state.dashboardState.lesseeRentals
  );
  const vehicles: VehicleType[] = useSelector(
    (state: any) => state.dashboardState.vehicles
  );

  const [availableVehicles, setAvailableVehicles] = useState<number>(0);

  useEffect(() => {
    const filteredVehicles = vehicles.filter(
      (vehicle) =>
        vehicle.rentals?.length &&
        vehicle.rentals.every(
          (rental) =>
            rental.rentalStatus !== "Active" && rental.rentalStatus !== "Booked"
        )
    );

    // const availableVehicles =  vehicles.filter(
    //   (vehicles) => vehicle.rentals?.lenght &&
    // )

    setAvailableVehicles(filteredVehicles?.length);
  }, [rentals]);

  return (
    <div className="flex w-full justify-between">
      <div className=" w-full md:w-[287px] flex-shrink-0">
        <div className="flex flex-col">
          <p
            className={`border rounded-[9px] bg-midGreen  text-white font-Inter text-sm lg:text-lg py-6 px-5 font-medium leading-5  `}
          >
            Total Listed Vehicles
          </p>
          <div className="bg-white border -mt-5 rounded-[9px] px-5  flex flex-col ">
            <div className="flex flex-row-reverse py-6 items-center">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                >
                  <path
                    d="M22.3079 20.2578H18.2674C13.3232 20.2578 12.2068 22.73 11.5954 25.7869L9.33594 36.5525H41.2341L38.9746 25.7869C38.3367 22.7566 37.2468 20.2578 32.3026 20.2578"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M44.8977 51.0144L45.1901 54.1245C45.4028 56.4637 43.5421 58.4839 41.1497 58.4839H37.4017C35.2485 58.4839 34.9561 57.5536 34.5574 56.4371L34.1587 55.241C33.6005 53.6195 33.2283 52.503 30.3575 52.503H20.15C17.2792 52.503 16.8539 53.7524 16.3488 55.241L15.9501 56.4371C15.5779 57.5802 15.2855 58.4839 13.1058 58.4839H9.35782C6.96546 58.4839 5.07812 56.4637 5.31736 54.1245L6.4338 41.9766C6.7262 38.9729 7.28444 36.5273 12.5211 36.5273H37.9599C43.1965 36.5273 43.7547 38.9729 44.0471 41.9766"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.30223 30.5703H7.30859"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M43.1968 30.5703H41.2031"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.2891 44.5234H19.27"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.2344 44.5234H37.2153"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M49.7358 23.2345C50.4801 21.5067 50.2142 19.1675 48.832 17.1207C47.4763 15.0739 45.4029 13.9309 43.5156 13.9575"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M48.8596 6.75177C47.3444 6.00748 45.7761 5.50248 44.2344 5.31641"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M58.0057 25.8642C59.1222 21.8503 58.3247 16.9328 55.4805 12.6797"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex-1 pb-4 border-b border-[#E7E6E6]">
                <p className="text-5xl text-[#3D475C] font-Inter font-normal leading-10 tracking-wide  ">
                  {vehicles.length ? vehicles.length : 0}
                </p>
              </div>
            </div>
            <div className="pb-3">
              <p className=" text-sm lg:text-base font-Inter font-medium leading-5  text-[#9499A1] tracking-tight ">
                All listed Vehicles
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className=" w-[287px] flex-shrink-0">
        <div className="flex flex-col">
          <p
            className={`border rounded-[9px] bg-darkGreen  text-white font-Inter text-sm lg:text-lg py-6 px-5 font-medium leading-5  `}
          >
            Inactive Vehicles
          </p>
          <div className="bg-white border -mt-5 rounded-[9px] px-5  flex flex-col ">
            <div className="flex flex-row-reverse py-6 items-center">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                >
                  <path
                    d="M22.3079 20.2578H18.2674C13.3232 20.2578 12.2068 22.73 11.5954 25.7869L9.33594 36.5525H41.2341L38.9746 25.7869C38.3367 22.7566 37.2468 20.2578 32.3026 20.2578"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M44.8977 51.0144L45.1901 54.1245C45.4028 56.4637 43.5421 58.4839 41.1497 58.4839H37.4017C35.2485 58.4839 34.9561 57.5536 34.5574 56.4371L34.1587 55.241C33.6005 53.6195 33.2283 52.503 30.3575 52.503H20.15C17.2792 52.503 16.8539 53.7524 16.3488 55.241L15.9501 56.4371C15.5779 57.5802 15.2855 58.4839 13.1058 58.4839H9.35782C6.96546 58.4839 5.07812 56.4637 5.31736 54.1245L6.4338 41.9766C6.7262 38.9729 7.28444 36.5273 12.5211 36.5273H37.9599C43.1965 36.5273 43.7547 38.9729 44.0471 41.9766"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.30223 30.5703H7.30859"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M43.1968 30.5703H41.2031"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.2891 44.5234H19.27"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.2344 44.5234H37.2153"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M49.7358 23.2345C50.4801 21.5067 50.2142 19.1675 48.832 17.1207C47.4763 15.0739 45.4029 13.9309 43.5156 13.9575"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M48.8596 6.75177C47.3444 6.00748 45.7761 5.50248 44.2344 5.31641"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M58.0057 25.8642C59.1222 21.8503 58.3247 16.9328 55.4805 12.6797"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex-1 pb-4 border-b border-[#E7E6E6]">
                <p className="text-5xl text-[#3D475C] font-Inter font-normal leading-10 tracking-wide  ">
                  {vehicles?.length - availableVehicles ?? 0}
                </p>
              </div>
            </div>
            <div className="pb-3">
              <p className=" text-sm lg:text-base font-Inter font-medium leading-5  text-[#9499A1] tracking-tight ">
                Vehicles with scheduled rentals
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className=" w-[287px] flex-shrink-0">
        <div className="flex flex-col">
          <p
            className={`border rounded-[9px] bg-lightGreen  text-white font-Inter text-sm lg:text-lg py-6 px-5 font-medium leading-5  `}
          >
            Available Vehicles
          </p>
          <div className="bg-white border -mt-5 rounded-[9px] px-5  flex flex-col ">
            <div className="flex flex-row-reverse py-6 items-center">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="64"
                  height="64"
                  viewBox="0 0 64 64"
                  fill="none"
                >
                  <path
                    d="M22.3079 20.2578H18.2674C13.3232 20.2578 12.2068 22.73 11.5954 25.7869L9.33594 36.5525H41.2341L38.9746 25.7869C38.3367 22.7566 37.2468 20.2578 32.3026 20.2578"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M44.8977 51.0144L45.1901 54.1245C45.4028 56.4637 43.5421 58.4839 41.1497 58.4839H37.4017C35.2485 58.4839 34.9561 57.5536 34.5574 56.4371L34.1587 55.241C33.6005 53.6195 33.2283 52.503 30.3575 52.503H20.15C17.2792 52.503 16.8539 53.7524 16.3488 55.241L15.9501 56.4371C15.5779 57.5802 15.2855 58.4839 13.1058 58.4839H9.35782C6.96546 58.4839 5.07812 56.4637 5.31736 54.1245L6.4338 41.9766C6.7262 38.9729 7.28444 36.5273 12.5211 36.5273H37.9599C43.1965 36.5273 43.7547 38.9729 44.0471 41.9766"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.30223 30.5703H7.30859"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M43.1968 30.5703H41.2031"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.2891 44.5234H19.27"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.2344 44.5234H37.2153"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M49.7358 23.2345C50.4801 21.5067 50.2142 19.1675 48.832 17.1207C47.4763 15.0739 45.4029 13.9309 43.5156 13.9575"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M48.8596 6.75177C47.3444 6.00748 45.7761 5.50248 44.2344 5.31641"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M58.0057 25.8642C59.1222 21.8503 58.3247 16.9328 55.4805 12.6797"
                    stroke="black"
                    stroke-width="3.98728"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="flex-1 pb-4 border-b border-[#E7E6E6]">
                <p className="text-5xl text-[#3D475C] font-Inter font-normal leading-10 tracking-wide  ">
                  {availableVehicles}
                </p>
              </div>
            </div>
            <div className="pb-3">
              <p className=" text-sm lg:text-base font-Inter font-medium leading-5  text-[#9499A1] tracking-tight ">
                Vehicles ready to go
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetails;
